import React from 'react';
import { useThemeLanguage } from '../context/ThemeLanguageContext';

export interface HomeflixLogoProps {
  theme?: 'dark' | 'light';
  className?: string;
}

export function HomeflixLogo({
  theme = 'dark',
  className = 'h-7 md:h-8 w-auto',
}: HomeflixLogoProps) {
  const { accentTheme, accentThemes } = useThemeLanguage();
  const currentAccent = accentThemes?.find((a) => a.id === accentTheme) || {
    id: 'crimson',
    name: 'Homeflix Crimson',
    nameHe: 'אדום נטפליקס',
    primary: '#E50914',
    glow: 'rgba(229, 9, 20, 0.4)',
  };

  const isLight = theme === 'light';
  // In light mode, HOME is deep black (#000000) for maximum clarity and contrast
  // In dark mode, HOME is crisp white (#FFFFFF)
  const homeTextColor = isLight ? '#000000' : '#FFFFFF';
  const primaryColor = currentAccent.primary;

  return (
    <svg
      viewBox="0 0 240 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} select-none shrink-0 transition-all duration-300`}
      aria-label="Homeflix"
      style={{ direction: 'ltr' }}
    >
      <defs>
        <linearGradient id={`hfLogoAccentGrad-${accentTheme}`} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={primaryColor} stopOpacity="1" />
          <stop offset="100%" stopColor={primaryColor} stopOpacity="0.85" />
        </linearGradient>
        <filter id={`hfLogoGlow-${accentTheme}`} x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="2" stdDeviation="3.5" floodColor={primaryColor} floodOpacity="0.5" />
        </filter>
      </defs>

      {/* Cinema House + Play Icon */}
      <g filter={`url(#hfLogoGlow-${accentTheme})`}>
        <path
          d="M22 4 L4 18 L7.5 21 L10 19 L10 37 C10 38.65 11.35 40 13 40 L31 40 C32.65 40 34 38.65 34 37 L34 19 L36.5 21 L40 18 Z"
          fill={`url(#hfLogoAccentGrad-${accentTheme})`}
          className="transition-all duration-300"
        />
        <polygon points="19,19 19,33 30,26" fill={isLight ? '#FFFFFF' : '#0A0A0A'} />
      </g>

      {/* HOMEFLIX Wordmark */}
      <text
        x="48"
        y="32"
        fontFamily="'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        fontWeight="900"
        fontSize="27"
        letterSpacing="-0.5"
        direction="ltr"
        textAnchor="start"
        style={{ direction: 'ltr', unicodeBidi: 'bidi-override' }}
      >
        <tspan fill={homeTextColor} className="transition-colors duration-200">
          HOME
        </tspan>
        <tspan fill={primaryColor} className="transition-colors duration-300">
          FLIX
        </tspan>
      </text>
    </svg>
  );
}

